'use strict';

// This is in the global scope to ensure it is accessible across the application
globalThis.lastActiveElementBeforeModal;

// TabsADA class to handle tab keyboard interactions and ARIA attributes
class TabsADA {
    constructor(groupNode) {
        this.tablistNode = groupNode;

        this.tabs = [];

        this.firstTab = null;
        this.lastTab = null;

        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabpanels = [];

        for (var i = 0; i < this.tabs.length; i += 1) {
            var tab = this.tabs[i];
            var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

            tab.tabIndex = -1;
            tab.setAttribute('aria-selected', 'false');
            this.tabpanels.push(tabpanel);

            tab.addEventListener('keydown', this.onKeydown.bind(this));
            tab.addEventListener('click', this.onClick.bind(this));

            if (!this.firstTab) {
                this.firstTab = tab;
            }
            this.lastTab = tab;
        }

        this.setSelectedTab(this.firstTab);
    }

    setSelectedTab(currentTab) {
        for (var i = 0; i < this.tabs.length; i += 1) {
            var tab = this.tabs[i];
            if (currentTab === tab) {
                tab.setAttribute('aria-selected', 'true');
                tab.removeAttribute('tabindex');
                this.tabpanels[i].classList.remove('is-hidden');
            } else {
                tab.setAttribute('aria-selected', 'false');
                tab.tabIndex = -1;
                this.tabpanels[i].classList.add('is-hidden');
            }
        }
    }

    moveFocusToTab(currentTab) {
        currentTab.focus();
    }

    moveFocusToPreviousTab(currentTab) {
        var index;

        if (currentTab === this.firstTab) {
            this.moveFocusToTab(this.lastTab);
        } else {
            index = this.tabs.indexOf(currentTab);
            this.moveFocusToTab(this.tabs[index - 1]);
        }
    }

    moveFocusToNextTab(currentTab) {
        var index;

        if (currentTab === this.lastTab) {
            this.moveFocusToTab(this.firstTab);
        } else {
            index = this.tabs.indexOf(currentTab);
            this.moveFocusToTab(this.tabs[index + 1]);
        }
    }

    /* EVENT HANDLERS */

    onKeydown(event) {
        var tgt = event.currentTarget,
            flag = false;

        switch (event.key) {
            case 'ArrowLeft':
                this.moveFocusToPreviousTab(tgt);
                flag = true;
                break;

            case 'ArrowRight':
                this.moveFocusToNextTab(tgt);
                flag = true;
                break;

            case 'Home':
                this.moveFocusToTab(this.firstTab);
                flag = true;
                break;

            case 'End':
                this.moveFocusToTab(this.lastTab);
                flag = true;
                break;

            default:
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onClick(event) {
        this.setSelectedTab(event.currentTarget);
    }
}

function resetDesktopSearch () {
    var $desktopSearch = $('#desktop-search');
    $desktopSearch.removeClass('open').attr('aria-expanded', 'false').find('.suggestions-wrapper').empty();
    $desktopSearch.find('input.search-field').val('');
    $desktopSearch.find('.reset-desktop-button').removeClass('d-sm-block').attr('tabindex', '-1');
    $desktopSearch.find('.fa-search').removeClass('d-none');
    $('header .site-search-trigger').attr('tabindex', '0');
}

document.addEventListener('DOMContentLoaded', function() {
    var tablists = document.querySelectorAll('[role=tablist].nav-tabs');
    for (var i = 0; i < tablists.length; i++) {
        new TabsADA(tablists[i]);
    }

    // Add event listener to the "Read More" label on PDP for keyboard accessibility
    var label = document.querySelector('.read-more-label');
    if (label) {
        var updateAriaExpanded = function() {
            var inputId = label.getAttribute('for');
            var input = document.getElementById(inputId);
            if (input) {
                input.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
                label.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
            }
        };

        label.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                label.click();
                updateAriaExpanded();
            }
        });

        label.addEventListener('click', function() {
            // Delay to ensure input.checked is updated after click
            setTimeout(updateAriaExpanded, 0);
        });
    }

    // Hero Banners have an optional background video..
    // Add event listener to the "Toggle Video" button in hero media
    // to allow users to play/pause the video
    $('body').on('click', '.hero-media .toggle-video', function(event) {
        event.preventDefault();
        var $playerContainer = $(this).closest('.hero-media').find('.video-player');
        var playerId = $playerContainer.attr('id');
        var player = window.Players[playerId];

        if (player) {
            // these 2 configs unsure the video does not play automatically when user scrolls the page
            player.config.autoplay = false;
            player.config.modal = false;
            if ($playerContainer.hasClass('video-stopped')) {
                $playerContainer.removeClass('video-stopped');
                player.play();
                $(this).attr('aria-pressed', true).addClass('playing').attr('title', 'Pause');
            } else {
                player.pause();
                $playerContainer.addClass('video-stopped');
                $(this).attr('aria-pressed', false).removeClass('playing').attr('title', 'Play');
            }
        }
    });

    $('body').on('invalid', 'form', function(event) {
        $(this).find('.is-invalid').first().focus();
    });

    $('body').on('click', '[data-toggle="modal"], .wishlist-card-product-add, .wishlist-card-product-remove, .affirm-modal-trigger, .wishlist-toggle-product', function() {
        globalThis.lastActiveElementBeforeModal = document.activeElement;

        //console.log('lastActiveElementBeforeModal:', globalThis.lastActiveElementBeforeModal);

        // Set focus on the first focusable element in the modal
        setTimeout(function() {
            var modal = document.querySelector('.modal.show');
            if (modal) {
                var firstFocusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (firstFocusable) {
                    firstFocusable.focus();
                }
            }
        }, 0);
    });

    $('.modal, body').on('hidden.bs.modal', function () {
        // Return focus to the last active element before the modal was opened
        //console.log('lastActiveElementBeforeModal:', globalThis.lastActiveElementBeforeModal);
        if (globalThis.lastActiveElementBeforeModal) {
            globalThis.lastActiveElementBeforeModal.focus();
        }
    });

    $('body').on('focusin', '.header-link.account-link, .header-column-2 .brand .logo-home', function(e) {
        $('body').trigger('reset:search', e);
    });

    // New Mega Menu Accessibility
    $('.mega-menu > ul > li').on('mouseenter focusin', function() {
        $(this).find('a').attr('aria-expanded', 'true');
    }).on('mouseleave focusout', function() {
        $(this).find('a').attr('aria-expanded', 'false');
    }).on('keydown', function(e) {
        var $focusedElement = $(document.activeElement);
        if (e.key === 'ArrowLeft') {
            $focusedElement.blur().closest('li.trigger').prev().find('a').first().focus();
        }
        if (e.key === 'ArrowRight') {
            $focusedElement.blur().closest('li.trigger').next().find('a').first().focus();
        }
        if (e.key === 'Escape') {
            $focusedElement.blur().closest('li.trigger').find('a').first().blur();
        }
    });

    $('.mega-menu').hoverIntent({
        over: function() {
            $(this).addClass('active');
        },
        out: function() {
            $(this).removeClass('active');
        },
        timeout: 200,
        selector: 'li.trigger'
    });

});

